document.addEventListener("DOMContentLoaded", () => {
  function initInfiniteScroll() {
    const productGrid = document.querySelector("#product-grid");
    const loadMoreWrapper = document.querySelector("#load-more");
    const loadMoreLink = loadMoreWrapper?.querySelector("a");

    // Store observer instance to disconnect later if needed
    let observerInstance = null;

    // Function scope variables
    let loading = false;
    const insertedEditorials = new Set();

    // Check if already initialized
    if (productGrid?.dataset.infiniteScrollInitialized === "true") {
      return;
    }
    if (productGrid) productGrid.dataset.infiniteScrollInitialized = "true";

    if (!productGrid || !loadMoreLink) {
      if (productGrid) delete productGrid.dataset.infiniteScrollInitialized;
      return;
    }

    // Remove old sentinel if it exists
    document.querySelector("#infinite-scroll-trigger")?.remove();

    const sentinel = document.createElement("div");
    sentinel.id = "infinite-scroll-trigger";
    sentinel.style.height = "1px";
    sentinel.style.margin = "60px auto";
    (productGrid.parentElement || productGrid).appendChild(sentinel);

    // Helper Functions
    const hasEditorialAssets = window.collectionEditorialImages && window.collectionEditorialImages.length > 0;

    function isMobile() {
      return window.innerWidth < 768;
    }

    function getEditorialAssets() {
      return window.collectionEditorialImages || [];
    }

    // Get current URL with all filters applied
    function getCurrentFilteredURL() {
      const currentUrl = new URL(window.location.href);
      const loadMoreUrl = new URL(loadMoreLink.href);
      
      // Preserve current filter parameters
      const filterParams = ['sort_by', 'filter', 'q'];
      filterParams.forEach(param => {
        if (currentUrl.searchParams.has(param)) {
          loadMoreUrl.searchParams.set(param, currentUrl.searchParams.get(param));
        }
      });
      
      // Also preserve any other filter parameters that might exist
      currentUrl.searchParams.forEach((value, key) => {
        if (key.startsWith('filter.') || key.includes('availability') || key.includes('price') || key.includes('vendor')) {
          loadMoreUrl.searchParams.set(key, value);
        }
      });
      
      return loadMoreUrl.href;
    }

    function insertEditorialBlock(position, blockIndex) {
      if (!hasEditorialAssets) return false;

      const assets = getEditorialAssets();
      if (assets.length === 0) return false;

      const items = productGrid.querySelectorAll("li.grid__item");
      if (items.length < position) return false;

      if (items[position - 1]?.nextElementSibling?.classList.contains("editorial-breaker")) {
        if (!insertedEditorials.has(position)) {
          insertedEditorials.add(position);
        }
        return false;
      }
      
      if (insertedEditorials.has(position)) return false;

      const wrapper = document.createElement("div");
      wrapper.className = "editorial-breaker";
      wrapper.dataset.position = position;
      wrapper.dataset.blockIndex = blockIndex;

      if (isMobile()) {
        const assetIndex = blockIndex % assets.length;
        const asset = assets[assetIndex];
        wrapper.dataset.assetIndex = assetIndex;

        wrapper.innerHTML = `
          <div class="editorial-inner editorial-inner--mobile">
            <div class="editorial-item">
              <img src="${asset.src}" alt="${asset.alt}" loading="lazy" />
              <p class="editorial-caption">${asset.caption}</p>
            </div>
          </div>
        `;
      } else {
        if (assets.length < 2 && assets.length > 0) {
          const assetIndex = (blockIndex * 2) % assets.length;
          const asset = assets[assetIndex];
          wrapper.dataset.assetIndex = assetIndex;
          wrapper.innerHTML = `
              <div class="editorial-inner editorial-inner--single-desktop">
                <div class="editorial-item">
                  <img src="${asset.src}" alt="${asset.alt}" loading="lazy" />
                  <p class="editorial-caption">${asset.caption}</p>
                </div>
              </div>
            `;
        } else if (assets.length >= 2) {
          const assetIndex1 = (blockIndex * 2) % assets.length;
          const assetIndex2 = (blockIndex * 2 + 1) % assets.length;

          const asset1 = assets[assetIndex1];
          const asset2 = assets[assetIndex2];

          wrapper.dataset.assetIndex1 = assetIndex1;
          wrapper.dataset.assetIndex2 = assetIndex2;

          wrapper.innerHTML = `
              <div class="editorial-inner">
                <div class="editorial-item">
                  <img src="${asset1.src}" alt="${asset1.alt}" loading="lazy" />
                  <p class="editorial-caption">${asset1.caption}</p>
                </div>
                <div class="editorial-item">
                  <img src="${asset2.src}" alt="${asset2.alt}" loading="lazy" />
                  <p class="editorial-caption">${asset2.caption}</p>
                </div>
              </div>
            `;
        } else {
          return false;
        }
      }

      items[position - 1].insertAdjacentElement("afterend", wrapper);
      insertedEditorials.add(position);
      return true;
    }

    function updateEditorials() {
      if (!hasEditorialAssets) return;

      const items = productGrid.querySelectorAll("li.grid__item");
      const totalItems = items.length;
      const assets = getEditorialAssets();
      const assetsAvailable = assets.length;

      if (assetsAvailable === 0) return;

      const insertFrequencyDesktop = 6;
      const insertFrequencyMobile = 4;

      if (isMobile()) {
        const targetNumberOfBlocks = Math.floor(totalItems / insertFrequencyMobile);
        const blocksToTryInserting = targetNumberOfBlocks;

        let insertedCount = 0;
        for (let i = 0; i < blocksToTryInserting; i++) {
          const position = (i + 1) * insertFrequencyMobile;
          const success = insertEditorialBlock(position, i);
          if (success) insertedCount++;
        }
      } else {
        const targetNumberOfBlocks = Math.floor(totalItems / insertFrequencyDesktop);
        const blocksToTryInserting = targetNumberOfBlocks;

        let insertedCount = 0;
        for (let i = 0; i < blocksToTryInserting; i++) {
          const position = (i + 1) * insertFrequencyDesktop;
          const success = insertEditorialBlock(position, i);
          if (success) insertedCount++;
        }
      }
    }

    function removeAllEditorials() {
      const editorials = document.querySelectorAll(".editorial-breaker");
      editorials.forEach((editorial) => editorial.remove());
      insertedEditorials.clear();
    }

    function loadMore() {
      if (loading) return;
      loading = true;

      // Use the filtered URL instead of the basic loadMoreLink.href
      const urlToFetch = getCurrentFilteredURL();

      fetch(urlToFetch)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.text();
        })
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newGridContent = doc.querySelector("#product-grid");
          const newItems = newGridContent ? newGridContent.querySelectorAll("li.grid__item") : [];
          const newLink = doc.querySelector("#load-more a");

          if (newItems.length > 0) {
            newItems.forEach((item) => productGrid.appendChild(item));
          }

          if (newLink) {
            loadMoreLink.href = newLink.href;
            loading = false;
            updateEditorials();
          } else {
            if (observerInstance) {
              observerInstance.disconnect();
            }
            window.removeEventListener("scroll", fallbackScrollCheck);
            sentinel.remove();
            if (loadMoreWrapper) loadMoreWrapper.remove();
            updateEditorials();
          }
        })
        .catch((err) => {
          console.error("❌ Infinite Scroll: Error loading products", err);
          loading = false;
        });
    }

    // Initialize Observer
    const observer = new IntersectionObserver(
      (entries) => {
        window.requestAnimationFrame(() => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && loadMoreLink && !loading) {
              loadMore();
            }
          });
        });
      },
      { rootMargin: "600px 0px" }
    );

    observer.observe(sentinel);
    observerInstance = observer;

    // Fallback scroll check
    function fallbackScrollCheck() {
      if (!sentinel || !sentinel.isConnected || !loadMoreLink) {
        window.removeEventListener("scroll", fallbackScrollCheck);
        return;
      }
      const triggerOffset = sentinel.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (triggerOffset < windowHeight + 800 && !loading) {
        loadMore();
      }
    }
    window.addEventListener("scroll", fallbackScrollCheck, { passive: true });

    // Initial check
    updateEditorials();

    // Handle resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        removeAllEditorials();
        updateEditorials();
      }, 250);
    });

    // Handle filter changes - this is the key addition for filter support
    function handleFilterChange() {
      // Reset everything when filters change
      removeAllEditorials();
      insertedEditorials.clear();
      loading = false;
      
      // Update the load more link to include current filters
      if (loadMoreLink) {
        const baseUrl = loadMoreLink.href.split('?')[0];
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('page', '2'); // Next page
        loadMoreLink.href = `${baseUrl}?${currentParams.toString()}`;
      }
      
      // Re-evaluate editorials for current visible products
      setTimeout(() => {
        updateEditorials();
      }, 100);
    }

    // Listen for URL changes (filter updates)
    let lastUrl = window.location.href;
    const urlObserver = new MutationObserver(() => {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        handleFilterChange();
      }
    });
    urlObserver.observe(document, { subtree: true, childList: true });

    // Also listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', handleFilterChange);

    // Listen for Shopify's filter events if available
    document.addEventListener('shopify:collection:filter', handleFilterChange);

    const cleanupInfiniteScroll = () => {
      if (observerInstance) {
        observerInstance.disconnect();
        observerInstance = null;
      }
      urlObserver.disconnect();
      window.removeEventListener("scroll", fallbackScrollCheck);
      window.removeEventListener('popstate', handleFilterChange);
      document.removeEventListener('shopify:collection:filter', handleFilterChange);
      document.querySelector("#infinite-scroll-trigger")?.remove();
      if (productGrid) delete productGrid.dataset.infiniteScrollInitialized;
    };

    return cleanupInfiniteScroll;
  }

  // Global Event Listeners & Initialization
  let currentCleanupFunction = null;

  const handleSectionLoad = (event) => {
    const productGridElement = event.target.querySelector("#product-grid");
    const productGridContainer = productGridElement
      ? productGridElement.closest("#ProductGridContainer")
      : event.target.querySelector("#ProductGridContainer");

    if (productGridContainer || productGridElement) {
      if (typeof currentCleanupFunction === "function") {
        currentCleanupFunction();
        currentCleanupFunction = null;
      }
      setTimeout(() => {
        currentCleanupFunction = initInfiniteScroll();
      }, 100);
    }
  };

  // Initial run
  currentCleanupFunction = initInfiniteScroll();

  document.addEventListener("shopify:section:load", handleSectionLoad);

  // MutationObserver for DOM changes
  const gridContainerElement = document.querySelector("#ProductGridContainer") || document.body;
  const mo = new MutationObserver((mutationsList) => {
    let gridMightNeedReinit = false;
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        const gridExists = document.querySelector("#product-grid");
        const sentinelExists = document.querySelector("#infinite-scroll-trigger");
        const isInitialized = gridExists?.dataset.infiniteScrollInitialized === "true";

        if (gridExists && (!isInitialized || !sentinelExists)) {
          gridMightNeedReinit = true;
          break;
        }
        
        if (mutation.addedNodes) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && (node.id === "product-grid" || node.querySelector("#product-grid"))) {
              const addedGrid = node.id === "product-grid" ? node : node.querySelector("#product-grid");
              if (addedGrid && addedGrid.dataset.infiniteScrollInitialized !== "true") {
                gridMightNeedReinit = true;
                break;
              }
            }
          }
        }
        if (gridMightNeedReinit) break;
      }
    }
    if (gridMightNeedReinit) {
      if (typeof currentCleanupFunction === "function") {
        currentCleanupFunction();
        currentCleanupFunction = null;
      }
      setTimeout(() => {
        currentCleanupFunction = initInfiniteScroll();
      }, 100);
    }
  });
  
  mo.observe(gridContainerElement, { childList: true, subtree: true });

  window.initInfiniteScroll = initInfiniteScroll;
  window.cleanupInfiniteScroll = currentCleanupFunction;
});